<template>

  <v-container grid-list-xl fluid="true" class="ma-0 pa-0">
    <v-form ref="form">
      <v-layout row wrap>

        <v-flex xs12>
          <h2>Mapeo de proyectos</h2>
          <p>Si tienes time entries sin mapear (en rojo) a la hora de sincronizar tus tiempos, busca en el proveedor dicho proyecto y mapealo con el proyecto de clockify.</p>
          <p>En el caso que el proyecto no exista en clockyfy pideselo a sistemas para que lo cree y acto seguido mapealo.</p>
        </v-flex>

        <v-flex xs12>
          <p>Selecciona un proveedor de origen y uno de destino</p>
          <p>Es importante que tengas en cuenta la direccionalidad del mapeo. No el lo mismo querer enviar tracks de tiempos del proveedor A -> B que de B -> A</p>


          <v-layout row wrap>
            <v-flex xs6>
              <h3>From</h3>
              <v-select
                  :items="registeredOriginProviders"
                  v-model="selectedProviderFrom"
                  label="Select the origin provider"
                  single-line
                  @change="getProviderProjects($event, 'providerProjectListFrom')"
              ></v-select>

              <v-select
                  :items="providerProjectListFrom"
                  v-model="selectedProviderProjectFrom"
                  label="Select the origin project"
                  single-line
              ></v-select>
            </v-flex>


            <v-flex xs6>
              <h3>To</h3>
              <v-select
                  :items="registeredDestinationProviders"
                  v-model="selectedProviderTo"
                  label="Select the destination provider"
                  single-line
                  @change="getProviderProjects($event, 'providerProjectListTo')"
              ></v-select>

              <v-select
                  :items="providerProjectListTo"
                  v-model="selectedProviderProjectTo"
                  label="Select the destination project"
                  single-line
              ></v-select>
            </v-flex>
          </v-layout>


        </v-flex>


        <v-flex xs12>
          <v-btn color="info" @click="save">Save</v-btn>

        </v-flex>

      </v-layout>
    </v-form>

    <br>
    <br>
    <br>

    <v-layout row wrap>
      <v-flex xs12>

        <table class="config-system-table">
          <thead>
          <tr>
            <th>From</th>
            <th>To</th>
            <th>Actions</th>
          </tr>
          </thead>
          <tr v-for="item in matchedProjects">
            <td>
              {{ getReadableOriginProjectLabel(item.providerFrom) }}
              <span class="font-weight-light caption">ID: {{ item.projectFrom }}</span>
            </td>
            <td>
              {{ getReadableDestinationProjectLabel(item.providerTo) }}
              <span class="font-weight-light caption">ID: {{ item.projectTo }}</span>
            </td>
            <td><a href="#" @click="deleteMatch(item._id, $event)">Delete</a></td>
          </tr>
        </table>
      </v-flex>
    </v-layout>

    <v-snackbar
        v-model="showSnackbar"
        bottom
        :timeout="2000"
    >
      Fill all required fields.
    </v-snackbar>
  </v-container>
</template>

<script>
import { mapState } from "vuex"
import rest from '@/plugins/rest'
import _ from "lodash"
import Utils from "@/plugins/Utils";

export default {
  data() {
    return {
      registeredOriginProviders: [],
      registeredDestinationProviders: [],

      selectedProviderFrom: null,
      selectedProviderProjectFrom: null,

      selectedProviderTo: null,
      selectedProviderProjectTo: null,

      providerProjectListFrom: [],
      providerProjectListTo: [],

      // List of already matched projects.
      matchedProjects: [],

      showSnackbar: false,
    }
  },

  methods: {
    getOriginProviders() {
      const self = this

      rest.getProviders().then(r => {
        r = Utils.subObject(r,
            ['type', 'label', '_id'],
            ['text', 'label', 'value']
        )

        self.registeredOriginProviders = []

        r.forEach(el => {
          self.registeredOriginProviders.push({
            text: `${el.label} (${el.text})`,
            value: el.value
          })
        })

      })
    },

    getDestinationProviders() {
      const self = this

      rest.getProviders().then(r => {
        r = Utils.subObject(r,
            ['type', 'label', '_id'],
            ['text', 'label', 'value']
        )

        self.registeredDestinationProviders = []

        r.forEach(el => {
          self.registeredDestinationProviders.push({
            text: `${el.label} (${el.text})`,
            value: el.value
          })
        })

      })
    },

    /**
     * Get provider projects from server.
     */
    getProviderProjects(providerId, model) {
      const self = this

      rest.getProjects(providerId).then(r => {
        self.fillProviderList(r, model);
      });
    },

    /**
     * Get matched projects from server.
     */
    getMatchedProjects() {
      rest.getMatchedProjects().then(r => {
        this.matchedProjects = r;
      })
    },

    /**
     * Process REST provider list into a <select> format.
     *
     * @param r
     * @param list
     */
    fillProviderList(r, list) {
      const self = this;
      self[list] = [];

      for (let item of r) {
        self[list].push({
          text: item.name,
          value: item.id
        })
      }

      self[list] = _.sortBy(self[list], 'text');
    },

    /**
     * Find the human readable project name from machine name project.
     */
    getReadableOriginProjectLabel(machineName) {
      for (let item of this.registeredOriginProviders) {
        if (item.value === machineName) {
          return item.text;
        }
      }
    },

    /**
     * Find the human readable project name from machine name project.
     */
    getReadableDestinationProjectLabel(machineName) {
      for (let item of this.registeredDestinationProviders) {
        if (item.value === machineName) {
          return item.text;
        }
      }
    },

    /**
     * Deletes a stored match.
     */
    deleteMatch(id, $event) {
      const self = this;
      $event.preventDefault();

      rest.deleteMatchedProject(id).then(r => {
        // Update the list:
        self.getMatchedProjects();
      })
    },

    /**
     * Stores matched projects.
     */
    save() {
      const self = this;

      // Check if some value is not filed.
      if (self.selectedProviderFrom === null ||
          self.selectedProviderProjectFrom === null ||
          self.selectedProviderTo === null ||
          self.selectedProviderProjectTo === null) {
        self.showSnackbar = true;
        return;
      }


      const data = {
        providerFrom: self.selectedProviderFrom,
        projectFrom: self.selectedProviderProjectFrom,
        providerTo: self.selectedProviderTo,
        projectTo: self.selectedProviderProjectTo,
      };

      rest.saveMatchedProject(data).then(r => {
        // Update the list:
        self.getMatchedProjects();

        // Reset form.
        self.selectedProviderFrom = null
        self.selectedProviderProjectFrom = null
        self.selectedProviderTo = null
        self.selectedProviderProjectTo = null
        self.providerProjectListFrom = []
        self.providerProjectListTo = []
      })
    },
  },

  computed: {
    ...mapState([
      'currentUser',
    ]),
  },

  mounted: function () {
    this.getOriginProviders()
    this.getDestinationProviders()
    this.getMatchedProjects();
  },


}
</script>

<style lang="scss">
table.config-system-table {
  width: 100%;
  border-collapse: collapse;

  th {
    background: #fefefe;
    padding: 10px;
    border: 1px solid grey;
    text-align: left;
  }

  td {
    padding: 10px;
    border: 1px solid grey;
  }
}
</style>